import {
  ON_SORT_ALPHABETICALLY_CHANGE,
  ON_SORT_BY_DATE_CHANGE,
  UPDATE_STATE_WITH_FETCHED_REPORT
} from '../actions';

const initialState = {
  data: {},
  options: {
    alphabetically: [{
      sort: 'byFirstName',
      value: 'first',
      label: ''
    }, {
      sort: 'byLastName',
      value: 'last',
      label: ''
    }],
    date: [{
      sort: 'byNewest',
      value: 'newest',
      label: ''
    }]
  },
  sorts: {
    sortAlphabetically: '',
    sortByDate: ''
  }
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {
    default: return state;

    case ON_SORT_ALPHABETICALLY_CHANGE: {
      return {
        ...state,
        data: {
          ...state.data,
          sortAlphabetically: action.payload
        }
      };
    }
    case ON_SORT_BY_DATE_CHANGE: {
      return {
        ...state,
        data: {
          ...state.data,
          sortByDate: action.payload
        }
      };
    }
    case UPDATE_STATE_WITH_FETCHED_REPORT: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/reports/reducers/custom-sorts.js